module.exports = __webpack_public_path__ + "media/images/bg-get-started-curve-95775af7.png";